import { generateAutomationName } from "../../../helpers/generateAutomationName";

export const itemKeys = {
    container: generateAutomationName("home", ["table", "item", "container"]),
};
